import { RemoteRequests } from '../../../data/usecases/requests/remote-requests'
import { makeAxiosHttpClient } from '../../factories/http/axios-http-client-factory'

export const makeRequests = (uri: string) => new RemoteRequests(uri, makeAxiosHttpClient())
